module.exports = __webpack_public_path__ + "img/icon109.2fad5452.png";